
import Component from './component';
import createComponentFactory from '../createComponent';
import { SSL_DOMAIN, SHOP_KEY, LOGIN_LINK, MYPAGE_LINK } from '../constant/FS2';

class UserLinkSwitch extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.text = element.querySelector('.js-userLinkSwitch__text');


  }

  _bindEvents() {

  }

  _unbindEvents() {

  }


  didRegisterComponent() {
    this._bindEvents();

    if(window.FS2 && window.FS2.repeater) {
      FS2.repeater({
        ssldomain: SSL_DOMAIN,
        shopKey: SHOP_KEY,
        member: (json) => {
          this.element.setAttribute('href', MYPAGE_LINK);
          this.text.innerText = 'マイページ';
        },
        guest: (json) => {
          this.element.setAttribute('href', LOGIN_LINK);
          this.text.innerText = 'ログイン';
        }
      });
    }

  }

  didUnregisterComponent() {
    this._unbindEvents();
  }
}


export default createComponentFactory(UserLinkSwitch);



// WEBPACK FOOTER //
// ./src/js/app/component/userLinkSwitch.js